// extracted by mini-css-extract-plugin
export default {"ot-privacy-notice-container":"PrivacyNoticePage_ot-privacy-notice-container__AZx8G"};